import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "../../assets/images/icons/BarrelAssignmentWarningIcon.svg";

// Add interface for props
interface BarrelOwnerAssignmentPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
  conflictCount?: number;
}

export default function BarrelOwnerAssignmentPopup({ 
  onConfirm, 
  onCancel, 
  conflictCount
}: BarrelOwnerAssignmentPopupProps) {
  const [selected, setSelected] = useState([""]);
  
  return (
    <>
      <div
        className="modal modal__wd modal__wd--submitSellReq fade show barrel-assignment-modal" // Added 'show'
        id="rejectUserModal"
        tabIndex={-1}
        aria-labelledby="rejectUserModalLabel"
        aria-hidden="false" // Changed from "true" to "false"
        style={{ display: 'block' }} // Added to make modal visible
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header flex-row align-items-center justify-content-between">
              <h1 className="modal-title" id="rejectUserModalLabel">
                Container Owner Assignment
              </h1>
              <button type="button" className="pt-1 p-0 bg-transparent border-0 text-light" onClick={onCancel}><CloseIcon/></button>
            </div>
            <div className="modal-body">
                <div className="text-center">
                  <span className="warning-icon-wrapper">
                    <img src={WarningIcon} alt="Warning Icon"/>
                  </span>
                </div>
              <h2 className="modal-body__title">Are you sure you want to assign these container to this owner?</h2>
              
              <p className="modal-text">
                Your selection includes {conflictCount} {conflictCount > 1 ? 'containers' : 'container'} currently assigned to other owners. 
                If you proceed, their ownership will be overwritten and reassigned to the selected owner.
              </p>
            </div>
            <div className="modal-footer">
              <div className=" d-flex justify-content-center gap-2 flex-wrap w-100">
                {/* <div className="col-6 ps-0"> */}
                  <button
                    type="button"
                    className="btn secondary-btn px-5"
                    onClick={onCancel} // Changed from data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                {/* </div>
                <div className="col-6 pe-0"> */}
                  <button 
                    type="button" 
                    className="btn primary-btn px-5"
                    onClick={onConfirm} // Added onClick handler
                  >
                    Ok
                  </button>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Added modal backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
}